import script from "./AutoAIAgentChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAIAgentChat.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAIAgentChat.vue?vue&type=style&index=0&id=3c0ada4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0ada4e"]])

export default __exports__